const TimeValues = [
  {
    name: "ثانیه",
    value: "s"
  },
  {
    name: "دقیقه",
    value: "m"
  },
  {
    name: "ساعت",
    value: "h"
  },
  {
    name: "روز",
    value: "d"
  },
  {
    name: "هفته",
    value: "w"
  },
  {
    name: "ماه",
    value: "M"
  },
  {
    name: "سال",
    value: "y"
  }
]
export default TimeValues;